import Subheading from 'components/Subheading';
import React, { ReactElement, ReactNode } from 'react';
import Separator from 'components/Separator';

interface IGoodToKnowSectionProps { 
  overrideSubheading?: ReactElement
  skipFirstSeparator?: boolean
  children?: JSX.Element[]
  style?: React.CSSProperties
}

const GoodToKnowSection = ({
  overrideSubheading,
  skipFirstSeparator,
  children,
  style = undefined,
}: IGoodToKnowSectionProps) => (
  <div
    className="paddedMaxWidthContainer goodToKnowSectionContainer"
    style={style}
  >
    {overrideSubheading !== null && (
      <Subheading
        Tag="h2"
        underlineColor="transparent"
        style={{
          width: '100%',
          borderLeft: '8px solid #B9F5E6',
          textAlign: 'left',
          paddingLeft: '0.4em',
        }}
      >
        {overrideSubheading || (
          <>
            Good To <strong>Know</strong>
          </>
        )}
      </Subheading>
    )}

    {children?.map((child: ReactNode, idx: number) => (
      <div key={idx} className="fullWidth flexCentered contentBlock">
        {idx === 0 && skipFirstSeparator ? null : (
          <Separator style={{ marginTop: idx === 0 ? '1em' : '2em' }} />
        )}
        {child}
      </div>
    ))}
    <style jsx>
      {`
        .goodToKnowSectionContainer {
          margin-top: 3em;
          padding-bottom: 2em;
          text-align: left;
        }

        :global(.contentBlock h2),
        :global(.contentBlock h3) {
          text-transform: none;
          letter-spacing: 0;
          width: 100%;
          text-align: left;
          font-weight: 700;
          font-size: 1.3em;
          margin-top: 1em;
        }

        :global(.goodToKnowSectionContainer h3) {
          font-size: 1.1em;
        }

        :global(.goodToKnowSectionContainer p) {
          width: 100%;
        }

        :global(.goodToKnowSectionContainer a) {
          font-weight: 700;
          text-decoration: underline;
        }
      `}
    </style>
  </div>
);

export default GoodToKnowSection;
